import { render, staticRenderFns } from "./message-template.vue?vue&type=template&id=330c6ee2"
import script from "./message-template.vue?vue&type=script&lang=js"
export * from "./message-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.27_babel-core@6.26.3_css-loader@6.11.0_webpack@5.92._4ybukp33xmar2t4t23nvjqqetu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports